var InputValidation;
(function (InputValidation) {
    var Controller = (function () {
        function Controller() {
        }

        Controller.prototype.IsValid = function (input, maxLength) {
            if (input === null || input === undefined)
                return false;

            if (input === "")
                return false;
            if (input.length > maxLength)
                return false;
            return true;
        }

        Controller.prototype.IsNotEmpty = function (input) {
            return input === "" ? false : true;
        }

        Controller.prototype.LengthIsValid = function (input, maxLength) {
            return input.length > maxLength ? false : true;
        }

        Controller.prototype.DoesMatch = function (input1, input2) {
            if (input1 === input2)
                return true;
            return false;
        }

        Controller.prototype.IsNumber = function(input) {
            if (!$.isNumeric(input))
                return false;
            return true;
        }

        return Controller;
    })();
    InputValidation.Controller = Controller;
})(InputValidation || (InputValidation = {}));
var inputValidator = new InputValidation.Controller();